import {
  PanelButtons,
  PanelContent,
  PanelTitle,
  QuickButton,
  QuickPanel,
} from '../QuickActions.styled';
import QuickIcon from './QuickIcon';

export const SimulationAction = () => (
  <QuickPanel>
    <QuickIcon icon="simulation" type="outline" />
    <PanelContent>
      <PanelTitle>Interactive Videos</PanelTitle>
      <PanelButtons>
        <QuickButton to="/simulations/new">Create</QuickButton>
        <QuickButton design="outline" to="/simulations">
          Browse
        </QuickButton>
      </PanelButtons>
    </PanelContent>
  </QuickPanel>
);

export default SimulationAction;
